import { ReactNode, Suspense, lazy } from 'react';
import { useLocation } from 'react-router-dom';

import {
  ExtensionDefinition,
  coreExtensionData,
  createExtension,
  createExtensionInput,
} from '@backstage/frontend-plugin-api';

import { isEmbedRoute } from '../../utils/embedRoutes';
import { isPublicRoute } from '../../utils/publicRoutes';
import { PublicLayout } from '../PublicLayout/PublicLayout';

const LazyLayout = lazy(() =>
  import('../Layout/Layout').then(m => ({ default: m.Layout })),
);
const LazySidebarMenu = lazy(() =>
  import('./SidebarMenu').then(m => ({
    default: m.SidebarMenu,
  })),
);

const LayoutContent = ({ content }: { content: ReactNode }) => {
  const location = useLocation();

  if (isPublicRoute(location.pathname) || isEmbedRoute(location.pathname)) {
    return <PublicLayout content={content} />;
  }

  return (
    <Suspense fallback={null}>
      <LazyLayout nav={<LazySidebarMenu />} content={content} />
    </Suspense>
  );
};

export const Layout = createExtension({
  name: 'layout',
  attachTo: { id: 'app/root', input: 'children' },
  inputs: {
    content: createExtensionInput([coreExtensionData.reactElement], {
      singleton: true,
    }),
  },
  output: [coreExtensionData.reactElement],
  *factory({ inputs }) {
    yield coreExtensionData.reactElement(
      <LayoutContent
        content={inputs.content.get(coreExtensionData.reactElement)}
      />,
    );
  },
}) as ExtensionDefinition;
